export const pushRedditConversionEvent = ({ event, userData, eventData }) => {
  if (typeof window === "undefined") {
    return;
  }

  const dataLayer = window.dataLayer || (window.dataLayer = []);

  const payload = { event };
  if (userData && Object.keys(userData).length > 0) {
    payload.user_data = userData;
  }
  if (eventData && Object.keys(eventData).length > 0) {
    payload.event_data = {
      page_path: window.location.pathname || "/",
      ...eventData,
    };
  }

  dataLayer.push(payload);
};
